<template>
  <div class="visualReport-container">
    <el-row :gutter="0" style="width: 100%">
      <el-form size="medium" label-width="90px">
        <el-col :span="8"><el-form-item :label="$t('bike.name1')" prop="tenantId">{{ itemdata.tenantName
            }}</el-form-item></el-col>
        <el-col :span="8" class="elCol">
          <el-form-item :label="$t('bike.name98')">{{ itemdata.ebikeId }}</el-form-item>
          <el-button type="text" style="margin-top: -23px; margin-left: 15px" @click="showDetailsDialog">{{
            $t('bike.name12') }}</el-button>
          <el-popover v-if="!topData.bindEbikeModel" placement="top-start" width="200" trigger="hover"
            :content="$t('bike.name463')">
            <img slot="reference" class="caution" src="@/assets/caution.png" alt="" />
          </el-popover>
        </el-col>
        <el-col :span="8"><el-form-item :label="$t('bike.name84')">{{ itemdata.startTime }} - {{ itemdata.endTime
            }}</el-form-item></el-col>
      </el-form>
    </el-row>
    <div class="top-ds">
      <div class="item">
        <div class="label">
          {{ $t('bike.name121') }}<span class="value">{{ topData.odo || '-' }}（Km）</span>
        </div>
        <div class="label">
          {{ $t('bike.name126') }}
          <span class="value" v-if="topData.speed">{{ Number(topData.speed / 10).toFixed(1) }}（Km/h）</span>
          <span class="value" v-else> -（Km/h）</span>
        </div>
      </div>
      <div class="item">
        <div class="label">
          {{ $t('bike.name122') }}<span class="value">{{ topData.maxPower || '-' }}（W）</span>
        </div>
        <div class="label margin-top10">
          {{ $t('bike.name296') }}
          <span class="value" v-if="topData.maxBatteryCurrent !== null">{{ Number(topData.maxBatteryCurrent /
            3).toFixed(1) }}（A）</span>
          <span class="value" v-else>-（A）</span>
        </div>
      </div>
      <!-- <div class="item">
      <div class="label">{{$t('bike.name124')}}<span class="value">{{ topData.maxVoltage || '-' }}（V）</span></div>
      <div class="label margin-top10">{{$t('bike.name125')}}<span class="value">{{ topData.mixVoltage || '-' }}（V）</span></div>
    </div> -->
      <div class="item">
        <div class="label">
          {{ $t('bike.name127') }}
          <span
            :class="Number(topData.maxTemp) + Number(topData.controllerTemperatureShowDeviation) > Number(topData.controllerTemperatureShowWarnDefaultValue) ? 'value redColor' : 'value'"
            v-if="topData.maxTemp !== null">{{ Number(topData.maxTemp) +
              Number(topData.controllerTemperatureShowDeviation) }}（°C）</span>
          <span class="value" v-else> -（°C）</span>
        </div>
        <div class="label margin-top10">
          {{ $t('bike.name297') }}
          <span
            :class="Number(topData.maxMotorTemp) + Number(topData.motorTemperatureShowDeviation) > Number(topData.motorTemperatureShowWarnDefaultValue) ? 'value redColor' : 'value'"
            v-if="topData.maxMotorTemp !== null">{{ Number(topData.maxMotorTemp) +
              Number(topData.motorTemperatureShowDeviation) }}（°C）</span>
          <span class="value" v-else> -（°C）</span>
        </div>
        <div class="label margin-top10">
          {{ $t('bike.name298') }}
          <span
            :class="Number(topData.maxBatteryTemp) + Number(topData.batteryTemperatureShowDeviation) > Number(topData.batteryTemperatureShowWarnDefaultValue) ? 'value redColor' : 'value'"
            v-if="topData.maxBatteryTemp !== null">{{ Number(topData.maxBatteryTemp) +
              Number(topData.batteryTemperatureShowDeviation) }}（°C）</span>
          <span class="value" v-else> -（°C）</span>
        </div>
      </div>
    </div>
    <div class="dydl-wd">
      <div class="wd-container">
        <div class="map-radio">
          <span>{{ $t('operate.name72') }}</span>
          <el-radio v-model="mapchange" label="1" @change="mapchangeradio">{{ $t('operate.name74') }}</el-radio>
          <el-radio v-model="mapchange" label="2" @change="mapchangeradio">{{ $t('operate.name73') }}</el-radio>
        </div>
        <div class="baidu-map" v-show="mapchange === '1'">
          <div class="query-form">
            <!-- <div class="gjsd">{{$t('operate.name75')}}<el-slider v-model="speedbaidu" @change="changeSlider" style="width: 200px" :step="1" :min="10"></el-slider></div> -->
            <div style="margin-top: 10px">
              <!-- <el-button type="primary" @click="handleQuery">{{$t('operate.name77')}}</el-button> -->
              <el-button type="primary" @click="handPathStop" v-if="isStart">{{ $t('operate.name78') }}</el-button>
              <el-button type="primary" @click="handPathStop" v-else>{{ $t('operate.name182') }}</el-button>
            </div>
          </div>
          <div id="mapDiv" class="map"></div>
          <!-- <baidu-map class="map" :center="markerPointbaidu" :zoom="20" :scroll-wheel-zoom='true' @ready="handleMap">
              <bm-polyline :path="pathbaidu" stroke-color="#275aff" :stroke-opacity="0.8" :stroke-weight="5"
                           :editing="false"
              ></bm-polyline>
              <bm-polyline :path="pathbaiduFault" stroke-color="#FF0000" :stroke-opacity="0.8" :stroke-weight="5"
                           :editing="false"
              ></bm-polyline>
              <bm-marker v-if='startmarkerPointbaidu.lng && startmarkerPointbaidu.lat' :position="startmarkerPointbaidu" :icon="startmarkericonbaidu"></bm-marker>
              <bm-marker v-if='startmarkerPointbaidu.lng && startmarkerPointbaidu.lat'  :position="endmarkerPointbaidu" :icon="endmarkericonbaidu"></bm-marker>
              <bml-lushu
               ref="lushu"
                :speed="speedbaidu*5"
                :path="pathbaidu"
                :icon="icon">
              </bml-lushu>
            </baidu-map> -->
        </div>
        <div class="gooles-map" v-if="mapchange === '2'">
          <!-- <template>
            <el-form ref="queryForm" :inline="true"  class="">
              <el-row>
                <el-col :span="6">
                  <el-form-item label="轨迹速度：">
                    <el-slider v-model="speed" style="width: 200px" :step="1" :min="10"
                               :input="inputspeed(speed)"></el-slider>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item style="float: left">
                    <el-button icon="el-icon-video-play" size="mini" @click="bikePolyLinestart">开始</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </template> -->
          <div class="query-form">
            <div class="gjsd">{{ $t('operate.name75') }}<el-slider v-model="speed" style="width: 200px" :step="1"
                :min="10" :input="inputspeed(speed)"></el-slider></div>
            <el-button icon="el-icon-video-play" @click="bikePolyLinestart" style="width: 100px">{{ $t('operate.name76')
            }}</el-button>
          </div>
          <GmapMap :center="markerPoint" :zoom="20" ref="mapRef" class="map" id="mapps">
            <gmap-marker @click="bikePolyLine" :position="startmarkerPoint" :icon="startmarkericon"> </gmap-marker>
            <gmap-marker :position="endmarkerPoint" :icon="endmarkericon"> </gmap-marker>
          </GmapMap>
        </div>
        <!-- <i class="el-icon-rank" @click="showFullMap"></i> -->
      </div>
      <div class="wd-container margin-left15">
        <div class="gz-table">
          <!-- <div class="title">故障表</div> -->
          <div class="table-title">
            <div class="row1">{{ $t('bike.name129') }}</div>
            <div class="row2">{{ $t('bike.name130') }}</div>
            <div class="row3">{{ $t('bike.name131') }}</div>
            <div class="row4">{{ $t('bike.name110') }}</div>
            <div class="row5">{{ $t('bike.name46') }}</div>
          </div>
          <div class="table-content">
            <div class="item-content" v-for="(item, index) in tableList" :key="index"
              :class="clickIndex === index ? 'item-content-active' : ''">
              <div class="icon" v-if="clickIndex === index"><img :src="caution" /></div>
              <div class="row1" v-if="item.list.length > 1 && item.list">
                <div style="cursor: pointer" @click="handlerIndex(item, index, 0)">{{ item.list[0].dataTime }}</div>
                <div style="cursor: pointer" @click="handlerIndex(item, index, item.list.length - 1)">{{
                  item.list[item.list.length - 1].dataTime }}</div>
              </div>
              <div class="row1" v-if="item.list.length == 1 && item.list" @click="handlerIndex(item, index, 0)">{{
                item.list[0].dataTime }}</div>
              <div v-if="item.list.length > 0" class="row2">
                <div>{{ item.list[0].faultCode }}</div>
              </div>
              <div v-if="item.list.length > 0" class="row3">
                <div v-show="item.list[0].faultCode !== '48'">{{ item.list[0].faultMessage }}</div>
              </div>
              <div v-if="item.list.length > 0" class="row4">
                <div>
                  <!-- <span v-if="item.list[0].lng && item.list[0].lat"></span>
              <span v-else>{{$t('bike.name465')}}{{$t('bike.name132')}}</span>
              <span v-if="item.list[item.list.length - 1].lng && item.list[item.list.length - 1].lat"></span>
              <span v-else>{{$t('bike.name466')}}{{$t('bike.name132')}}</span> -->
                  <span v-if="item.list[0].isLocation === 0">{{ $t('public.name59') }}</span>
                </div>
              </div>
              <div class="row5">
                <el-button @click="showFaultDetalis(item)" type="text">{{ $t('bike.name12') }}</el-button>
              </div>
            </div>
            <div v-if="tableList.length === 0" class="nodata">{{ $t('bike.name133') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="dydl-wd margin-top20">
      <div style="width: 30%; border: 1px solid #f1f1f1; padding: 10px">
        <div style="display: flex; justify-content: space-between">
          <div>{{ $t('public.name55') }}（{{ batteryVoltage.batteryVoltageList.length }}）</div>
          <div>{{ $t('public.name56') }}{{ batteryVoltage.dateTime }}</div>
        </div>
        <el-table height="360px" :data="batteryVoltage.batteryVoltageList"
          :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }">
          <el-table-column :label="$t('public.name58')" prop="batteryNo" width="80"></el-table-column>
          <el-table-column :label="$t('public.name57')" prop="batteryVoltage">
            <template slot-scope="scope">
              <div>
                {{ (scope.row.batteryVoltage / 100).toFixed(2) }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="dydl-container margin-left15" style="width: 35%">
        <div class="bll-select">
          <el-select v-model="blData" multiple collapse-tags :placeholder="$t('public.name1')" @change="changeBL">
            <el-option v-for="item in typeOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </div>
        <div class="dydl">
          <MultipleLine ref="MultipleLineChart" chartid="MultipleLineChart" />
        </div>
      </div>
      <div class="dydl-container margin-left15" style="width: 35%">
        <div class="dcdy">
          <div class="writing-mode">{{ $t('bike.name55') }}</div>
          <div>/</div>
          <div>V</div>
        </div>
        <div class="dydl" id="dydlChart" ref="dydlChart"></div>
        <div class="dcdl">
          <div class="writing-mode">{{ $t('bike.name56') }}</div>
          <div>/</div>
          <div>A</div>
          <div class="writing-mode">{{ $t('bike.name495') }}</div>
        </div>
      </div>
    </div>
    <div class="dydl-wd margin-top20">
      <div class="wd-container">
        <div class="wd-text">
          <div class="writing-mode">{{ $t('bike.name144') }}</div>
          <div>/</div>
          <div>°C</div>
        </div>
        <div class="wd" id="wdChart" ref="wdChart"></div>
      </div>
      <div class="dydl-container margin-left15">
        <div class="dcdy">
          <div class="writing-mode">{{ $t('bike.name140') }}</div>
        </div>
        <div class="dydl" id="glsdChart" ref="glsdChart"></div>
        <div class="dcdl">
          <div class="writing-mode">{{ $t('bike.name141') }}</div>
          <div>/</div>
          <div>km/h</div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" :fullscreen="true" :modal="false" :show-close="true"
      :title="$t('bike.name82')" class="full-map">
      <div class="query-form">
        <div class="gjsd">{{ $t('operate.name84') }}<el-slider v-model="speedbaidu" @change="changeSlider"
            style="width: 200px" :step="1" :min="10"></el-slider></div>
        <div>
          <!-- <el-button type="primary" @click="handleQuery">{{$t('operate.name77')}}</el-button> -->
          <el-button type="primary" @click="handPathStop" v-if="isStart">{{ $t('operate.name78') }}</el-button>
          <el-button type="primary" @click="handPathStop" v-else>{{ $t('operate.name182') }}</el-button>
        </div>
      </div>
      <i class="el-icon-rank" @click="closeFullMap"></i>
      <baidu-map class="map" :center="markerPointbaidu" :zoom="20" :scroll-wheel-zoom="true" @ready="handleMap">
        <bm-polyline :path="pathbaidu" stroke-color="#275aff" :stroke-opacity="0.8" :stroke-weight="5"
          :editing="false"></bm-polyline>
        <bm-polyline :path="pathbaiduFault" stroke-color="#FF0000" :stroke-opacity="0.8" :stroke-weight="5"
          :editing="false"></bm-polyline>
        <bm-marker v-if="startmarkerPointbaidu.lng && startmarkerPointbaidu.lat" :position="startmarkerPointbaidu"
          :icon="startmarkericonbaidu"></bm-marker>
        <bm-marker v-if="startmarkerPointbaidu.lng && startmarkerPointbaidu.lat" :position="endmarkerPointbaidu"
          :icon="endmarkericonbaidu"></bm-marker>
        <!-- <bm-marker v-for="(item,index) in pointsMarker" :key="index" :position="item.fault" :icon="item.dataTime === dataTime ? pointsmarkericon1 : pointsmarkericon"></bm-marker> -->
        <bml-lushu ref="lushu" :speed="speedbaidu * 5" :path="pathbaidu" :icon="icon"> </bml-lushu>
      </baidu-map>
    </el-dialog>
    <!--车辆详情-->
    <el-dialog :title="$t('bike.name161')" :visible.sync="eBikeDetailsDialog" v-if="eBikeDetailsDialog"
      :append-to-body="true" :before-close="close" width="1440px">
      <EBikeDetailsDialog ref="eBikeDetailsDialog" :e-bike-id="eBikeId" :type="type"></EBikeDetailsDialog>
    </el-dialog>

    <el-dialog title="故障详情" :append-to-body="true" v-if="dialogFaultVisible" :visible.sync="dialogFaultVisible"
      width="30%" :before-close="handleCloseFault">
      <el-table :data="faultDetalisList" style="width: 100%">
        <el-table-column prop="dataTime" :label="$t('bike.name129')"> </el-table-column>
        <el-table-column prop="faultCode" :label="$t('bike.name130')"> </el-table-column>
        <el-table-column prop="faultMessage" :label="$t('bike.name131')"> </el-table-column>
        <el-table-column prop="isLocation" :label="$t('bike.name496')">
          <template slot-scope="scope">
            <div>{{ [$t('public.name60'), $t('bike.name45')][scope.row.isLocation] }}</div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getSize } from '@/utils/utils.js'
import { BmlLushu } from 'vue-baidu-map'
import coordtransform from 'coordtransform'
import { gmapApi } from 'vue2-google-maps'
import MultipleLine from '@/components/MultipleLine1.vue'
import EBikeDetailsDialog from '../components/eBikeDetailsDialog.vue'
import { lineCharTemp, lineChartBatteryVoltageCurrent, lineChartSpeedPowerPercent, listFields, lineChartFields, lngLatAlt, statistics, ebikeDBatteryVoltageList } from '@/api/bike.js'
export default {
  props: {
    itemdata: {
      type: Object,
      default: () => { },
    },
  },
  computed: {
    ...mapGetters(['userinfo']),
    google: gmapApi
  },
  components: {
    BmlLushu,
    MultipleLine,
    EBikeDetailsDialog
  },
  data () {
    return {
      type: 2,
      dialogFaultVisible: false,
      eBikeDetailsDialog: false,
      batteryVoltage: {
        dateTime: '',
        batteryVoltageList: []
      },
      faultDetalisList: [],
      eBikeDetails: {},
      eBikeId: '',
      showBaseInfoType: 1,
      topData: {
        bindEbikeModel: true,
        speed: 0,
        maxTemp: 0,
        minTemp: 0
      },
      loading: false,
      dialogVisible: false,
      caution: require('@/assets/caution1.png'),
      lineChart1: null,
      lineChart2: null,
      blData: [],
      blLabel: '',
      typeOptions: [],
      mapchange: '1',
      car_animate: null,
      count: 0,
      count2: 0,
      markerPoint: {
        lng: 0,
        lat: 0
      },
      icon: {
        url: require('@/assets/bike.png'),
        size: {
          width: 32,
          height: 32
        },
        opts: {
          imageSize: {
            width: 32,
            height: 32
          }
        }
      },
      startmarkericon: {
        url: require('@/assets/start.png'),
        size: {
          width: 32,
          height: 32
        },
        scaledSize: {
          width: 32,
          height: 32
        }
      },
      endmarkericon: {
        url: require('@/assets/end.png'),
        size: {
          width: 32,
          height: 32
        },
        scaledSize: {
          width: 32,
          height: 32
        }
      },
      bikemarkericon: {
        url: require('@/assets/bike.png'),
        size: {
          width: 32,
          height: 32
        },
        scaledSize: {
          width: 32,
          height: 32
        }
      },
      startmarkerPoint: {
        lng: 0,
        lat: 0
      },
      endmarkerPoint: {
        lng: 0,
        lat: 0
      },
      startmarkericonbaidu: {
        url: require('@/assets/start.png'),
        size: {
          width: 32,
          height: 32
        },
        opts: {
          imageSize: {
            width: 32,
            height: 32
          }
        }
      },
      endmarkericonbaidu: {
        url: require('@/assets/end.png'),
        size: {
          width: 32,
          height: 32
        },
        opts: {
          imageSize: {
            width: 32,
            height: 32
          }
        }
      },
      pointsmarkericon: {
        url: require('@/assets/caution.png'),
        size: {
          width: 16,
          height: 16
        },
        opts: {
          imageSize: {
            width: 16,
            height: 16
          }
        }
      },
      pointsmarkericon1: {
        url: require('@/assets/caution1.png'),
        size: {
          width: 32,
          height: 32
        },
        opts: {
          imageSize: {
            width: 32,
            height: 32
          }
        }
      },
      markerPointbaidu: {
        lng: 0,
        lat: 0
      },
      startmarkerPointbaidu: {
        lng: 0,
        lat: 0
      },
      endmarkerPointbaidu: {
        lng: 0,
        lat: 0
      },
      timer: null,
      markerBlack: null,
      BMap: null,
      map: null,
      pointsMarker: [],
      path: [],
      bikePath: [],
      speed: 20,
      speedbaidu: 30,
      pathbaidu: [],
      carTrack: null,
      carTrack1: null,
      playbaidu: false,
      isStart: false,
      clickIndex: -1,
      queryInfo: {
        searchTime: [],
        ebikeId: ''
      },
      vehicles: [],
      tableList: [],
      flightPath: null,
      xWDData: [],
      yWDData1: [],
      yWDData2: [],
      yWDData3: [],
      xDLDYData: [],
      yDLDYData1: [],
      yDLDYData2: [],
      xSDGLData: [],
      ySDGLData1: [],
      ySDGLData2: [],
      xBLData: [],
      yBLData: [],
      bLLegend: [],
      dataTime: '',
      faultMessage: '',
      pickerMinDate: '',
      maxDate: null,
      minDate: null,
      tdtMap: null,
      drivingRoute: null,
      pathbaiduFault: [],
      googleFault: [],
      trackPolyline: null,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近6小时',
            onClick: (picker) => {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 6 * 60 * 60 * 1000)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        disabledDate: time => {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  created () {
    this.queryInfo.searchTime = [this.itemdata.startTime, this.itemdata.endTime]
    this.queryInfo.ebikeId = this.itemdata.ebikeId
    window.addEventListener('resize', this.chartResize)
  },
  mounted () {
    this.lineChart1 = this.$echarts.init(this.$refs.dydlChart, null, { renderer: 'svg' })
    this.lineChart2 = this.$echarts.init(this.$refs.wdChart, null, { renderer: 'svg' })
    this.lineChart3 = this.$echarts.init(this.$refs.glsdChart, null, { renderer: 'svg' })
    // this.lineChart4 = this.$echarts.init(this.$refs.bllChart, null, { renderer: 'svg' })
    this.firstcharts()
    this.thirdcharts()
    // this.fourthcharts()
    this.getData()
  },
  beforeDestroy () {
    this.carTrack.pause()
    this.tdtMap = null
    this.carTrack = null
    this.playbaidu = false
    this.isStart = true
    window.removeEventListener('resize', this.chartResize)
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    showFaultDetalis (item) {
      console.log('==', item)
      this.faultDetalisList = item.list
      this.dialogFaultVisible = true
    },
    handleCloseFault () {
      this.dialogFaultVisible = false
    },
    showFullMap () {
      this.dialogVisible = true
    },
    closeFullMap () {
      this.dialogVisible = false
    },
    close () {
      this.$refs.eBikeDetailsDialog.close()
      this.eBikeDetailsDialog = false
    },
    showDetailsDialog () {
      this.eBikeId = this.itemdata.ebikeId
      this.eBikeDetailsDialog = true
    },
    changeDateTime (e) {
      if (this.$moment(e[1]).valueOf() - this.$moment(e[0]).valueOf() > 21600000) {
        this.$message({
          message: '请选择六个小时内的时间',
          type: 'warning'
        })
        this.queryInfo.searchTime = []
      }
    },
    getData () {
      this.timer = setInterval(this.getEbikeDBatteryVoltageList, 10000)
      this.xWDData = []
      this.yWDData1 = []
      this.yWDData2 = []
      this.yWDData3 = []
      this.xDLDYData = []
      this.yDLDYData1 = []
      this.yDLDYData2 = []
      this.xSDGLData = []
      this.ySDGLData1 = []
      this.ySDGLData2 = []
      this.xBLData = []
      this.yBLData = []
      this.blData = []
      this.firstcharts()
      this.secondcharts()
      this.thirdcharts()
      // this.fourthcharts()
      const data = {
        ebikeId: this.queryInfo.ebikeId,
        startTime: this.queryInfo.searchTime[0],
        endTime: this.queryInfo.searchTime[1]
      }
      statistics(data)
        .then((res) => {
          this.topData = res.data
          lineCharTemp(data).then((res) => {
            res.data.map((item) => {
              this.xWDData.push(item.dataTime)
              var controllerTemp = 0
              if (item.controllerTemp !== null) {
                controllerTemp = Number(item.controllerTemp) + Number(this.topData.controllerTemperatureShowDeviation)
              }
              this.yWDData1.push(controllerTemp)
              var motorTemp = 0
              if (item.motorTemp !== null) {
                motorTemp = Number(item.motorTemp) + Number(this.topData.motorTemperatureShowDeviation)
              }
              this.yWDData2.push(motorTemp)
              var batteryTemp = 0
              if (item.batteryTemp !== null) {
                batteryTemp = Number(item.batteryTemp) + Number(this.topData.batteryTemperatureShowDeviation)
              }
              this.yWDData3.push(batteryTemp)
            })
            this.secondcharts()
          }).catch(() => { })
        }).catch(() => { })
      lineChartBatteryVoltageCurrent(data)
        .then((res) => {
          res.data.map((item) => {
            this.xDLDYData.push(item.dataTime)
            const batteryVoltage = Number(item.batteryVoltage / 10).toFixed(1)
            this.yDLDYData1.push(batteryVoltage)
            const batteryCurrent = Number(item.batteryCurrent / 3).toFixed(1)
            this.yDLDYData2.push(batteryCurrent)
          })
          this.firstcharts()
        })
        .catch(() => { })
      lineChartSpeedPowerPercent(data)
        .then((res) => {
          res.data.map((item) => {
            this.xSDGLData.push(item.dataTime)
            this.ySDGLData1.push(item.powerPercent)
            const speed = item.speedMessage
            this.ySDGLData2.push(speed)
          })
          this.thirdcharts()
        })
        .catch(() => { })
      listFields()
        .then((res) => {
          this.typeOptions = res.data
          this.blData.push(this.typeOptions[0].id)
          this.blLabel = this.typeOptions[0].name
          this.typeOptions.map((item) => {
            this.blData.map((items) => {
              if (item.id === items) {
                this.bLLegend.push(item.name + '(' + item.unit + ')')
              }
            })
          })
          this.getBLChartData()
        })
        .catch(() => { })
      this.getEbikeDBatteryVoltageList()
      this.getlngLatAlt()
    },
    getEbikeDBatteryVoltageList () {
      ebikeDBatteryVoltageList({ ebikeId: this.queryInfo.ebikeId })
        .then((res) => {
          this.batteryVoltage = {
            dateTime: res.data ? res.data.dateTime : '',
            batteryVoltageList: res.data ? res.data.batteryVoltageDetails : []
          }
        })
        .catch(() => { })
    },
    changeBL (e) {
      this.blData = e
      this.bLLegend = []
      this.xBLData = []
      console.log('===1', this.blData)
      console.log('===3', this.typeOptions)
      this.blData.map((items) => {
        this.typeOptions.map((item) => {
          if (item.id === items) {
            this.bLLegend.push(item.name + '(' + item.unit + ')')
          }
        })
      })
      this.getBLChartData()
    },
    getBLChartData () {
      // console.log('this.typeOptions====', this.typeOptions)
      // console.log('this.blData====', this.blData)
      const data = {
        ebikeId: this.queryInfo.ebikeId,
        startTime: this.queryInfo.searchTime[0],
        endTime: this.queryInfo.searchTime[1],
        fieldKeys: this.blData.join(',')
      }
      lineChartFields(data)
        .then((res) => {
          const arrays = []
          this.blData.map(() => {
            arrays.push([])
          })
          // console.log('====', arrays.length)
          res.data.map((item) => {
            this.xBLData.push(item.dataTime)
            for (const key in item.keyValue) {
              var element = item.keyValue[key]
              this.blData.map((item, index) => {
                if (item === key) {
                  if (key === 'CONTROLLER_TEMP') {
                    element = Number(element) + Number(this.topData.controllerTemperatureShowDeviation)
                  } else if (key === 'BATTERY_TEMP') {
                    element = Number(element) + Number(this.topData.batteryTemperatureShowDeviation)
                  } else if (key === 'MOTOR_TEMP') {
                    element = Number(element) + Number(this.topData.motorTemperatureShowDeviation)
                  }
                  arrays[index].push(element)
                }
              })
            }
          })
          // console.log('this.blData====', this.blData)
          // console.log('this.blData====', this.bLLegend)
          this.$refs.MultipleLineChart.setOptions(this.xBLData, arrays, this.bLLegend)
          // this.fourthcharts()
        })
        .catch(() => { })
    },
    resetQuery () {
      this.queryInfo.ebikeId = ''
      this.queryInfo.searchTime = []
      this.getData()
    },
    chartResize () {
      if (this.lineChart2) {
        setTimeout(() => {
          this.lineChart2.resize()
          this.secondcharts()
        }, 10)
      }
      if (this.lineChart1) {
        setTimeout(() => {
          this.lineChart1.resize()
          this.firstcharts()
        }, 10)
      }
      if (this.lineChart3) {
        setTimeout(() => {
          this.lineChart3.resize()
          this.thirdcharts()
        }, 10)
      }
    },
    async firstcharts () {
      const option = {
        title: { text: this.$t('bike.name134'), left: 'center' },
        color: ['#42bf7c', '#5a7ff1'],
        grid: {
          left: getSize(20),
          right: getSize(20),
          top: getSize(50),
          bottom: getSize(40),
          containLabel: true
        },
        tooltip: {
          // backgroundColor: '#3a3b3c',
          trigger: 'axis',
          position: function (point, params, dom, rect, size) {
            var x = 0
            var y = 0
            var pointX = point[0]
            var pointY = point[1]
            var boxWidth = size.contentSize[0]
            var boxHeight = size.contentSize[1]
            if (boxWidth > pointX) {
              x = 5
            } else {
              x = pointX - boxWidth
            }
            if (boxHeight > pointY) {
              y = 5
            } else {
              y = pointY - boxHeight
            }
            return [x, y]
          }
        },
        legend: {
          data: [this.$t('bike.name142') + '(V)', this.$t('bike.name143') + '(A)'],
          top: getSize(20)
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: this.yDLDYData2.length
          },
          {
            start: 0,
            end: this.yDLDYData2.length
          }
        ],
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: false
          },
          data: this.xDLDYData
        },
        yAxis: [{ type: 'value' }, { type: 'value' }],
        series: [
          {
            name: this.$t('bike.name142') + '(V)',
            yAxisIndex: 0,
            data: this.yDLDYData1,
            symbolSize: 5,
            symbol: 'none',
            type: 'line'
          },
          {
            name: this.$t('bike.name143') + '(A)',
            yAxisIndex: 1,
            data: this.yDLDYData2,
            symbolSize: 5,
            symbol: 'none',
            type: 'line'
          }
        ]
      }
      this.lineChart1.setOption(option)
    },
    async secondcharts () {
      const option = {
        title: { text: this.$t('bike.name135'), left: 'center' },
        color: ['#42bf7c', '#5a7ff1', '#8a2ff1'],
        grid: {
          left: getSize(20),
          right: getSize(20),
          top: getSize(50),
          bottom: getSize(40),
          containLabel: true
        },
        tooltip: {
          // backgroundColor: '#3a3b3c',
          trigger: 'axis',
          position: function (point, params, dom, rect, size) {
            var x = 0
            var y = 0
            var pointX = point[0]
            var pointY = point[1]
            var boxWidth = size.contentSize[0]
            var boxHeight = size.contentSize[1]
            if (boxWidth > pointX) {
              x = 5
            } else {
              x = pointX - boxWidth
            }
            if (boxHeight > pointY) {
              y = 5
            } else {
              y = pointY - boxHeight
            }
            return [x, y]
          }
        },
        legend: {
          data: [this.$t('bike.name137'), this.$t('bike.name138'), this.$t('bike.name139')],
          top: getSize(20)
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: this.yWDData1.length
          },
          {
            start: 0,
            end: this.yWDData1.length
          },
          {
            start: 0,
            end: this.yWDData1.length
          }
        ],
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: false
          },
          data: this.xWDData
        },
        yAxis: { type: 'value' },
        series: [
          {
            name: this.$t('bike.name137'),
            data: this.yWDData1,
            symbolSize: 5,
            symbol: 'none',
            type: 'line'
          },
          {
            name: this.$t('bike.name138'),
            data: this.yWDData2,
            symbolSize: 5,
            symbol: 'none',
            type: 'line'
          },
          {
            name: this.$t('bike.name139'),
            data: this.yWDData3,
            symbolSize: 5,
            symbol: 'none',
            type: 'line'
          }
        ]
      }
      this.lineChart2.setOption(option)
    },
    async thirdcharts () {
      const option = {
        title: { text: this.$t('bike.name136'), left: 'center' },
        color: ['#42bf7c', '#5a7ff1'],
        grid: {
          left: getSize(20),
          right: getSize(20),
          top: getSize(50),
          bottom: getSize(40),
          containLabel: true
        },
        tooltip: {
          // backgroundColor: '#3a3b3c',
          trigger: 'axis',
          position: function (point, params, dom, rect, size) {
            var x = 0
            var y = 0
            var pointX = point[0]
            var pointY = point[1]
            var boxWidth = size.contentSize[0]
            var boxHeight = size.contentSize[1]
            if (boxWidth > pointX) {
              x = 5
            } else {
              x = pointX - boxWidth
            }
            if (boxHeight > pointY) {
              y = 5
            } else {
              y = pointY - boxHeight
            }
            return [x, y]
          }
        },
        legend: {
          data: [this.$t('bike.name140'), this.$t('bike.name141') + '(km/h)'],
          top: getSize(20)
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: this.ySDGLData1.length
          },
          {
            start: 0,
            end: this.ySDGLData1.length
          }
        ],
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: false
          },
          data: this.xSDGLData
        },
        yAxis: [{ type: 'value' }, { type: 'value' }],
        series: [
          {
            name: this.$t('bike.name140'),
            yAxisIndex: 0,
            data: this.ySDGLData1,
            symbolSize: 5,
            symbol: 'none',
            type: 'line'
          },
          {
            name: this.$t('bike.name141') + '(km/h)',
            yAxisIndex: 1,
            data: this.ySDGLData2,
            symbolSize: 5,
            symbol: 'none',
            type: 'line'
          }
        ]
      }
      this.lineChart3.setOption(option)
    },
    handlerIndex (item, index, dataIndex) {
      if (this.mapchange === '1') {
        this.pathbaiduFault = []
        this.dataTime = item.list[dataIndex].dataTime
        item.list.map((items) => {
          if (items.lng && items.lat) {
            // const bikepoints = coordtransform.wgs84togcj02(items.lng, items.lat)
            // const bikepointss = coordtransform.gcj02tobd09(bikepoints[0], bikepoints[1])
            // this.pathbaiduFault.push({ lng: Number(bikepointss[0]), lat: Number(bikepointss[1]) })
            this.pathbaiduFault.push({ lng: items.lng, lat: items.lat })
          }
        })
        // console.log('===', item.list)
        this.clickIndex = index
        const that = this

        // 移除之前的所有轨迹
        if (that.trackPolyline) {
          that.tdtMap.removeOverLay(that.trackPolyline)
          that.trackPolyline = null
        }

        var T = window.T

        // 确保数据格式正确
        if (this.pathbaiduFault && this.pathbaiduFault.length > 0) {
          // 转换坐标数据
          const trackPoints = this.pathbaiduFault.map(item => {
            return new T.LngLat(item.lng || item[0], item.lat || item[1])
          })

          // 创建轨迹线
          that.trackPolyline = new T.Polyline(trackPoints, {
            color: '#ff0000',
            weight: 8,
            opacity: 0.8,
          })

          // 添加到地图
          that.tdtMap.addOverLay(that.trackPolyline)
        }
      } else {
        // this.clickIndex = index
        this.googleFault = []
        this.dataTime = item.list[dataIndex].dataTime
        item.list.map((items) => {
          if (items.lng && items.lat) {
            this.clickIndex = index
            const bikepoints = coordtransform.wgs84togcj02(items.lng, items.lat)
            this.googleFault.push({ lng: Number(bikepoints[0]), lat: Number(bikepoints[1]) })
          }
        })
        if (this.flightPath !== null) {
          this.flightPath.setMap(null)
        }
        var lineSymbol = {
          path: this.google.maps.SymbolPath.FORWARD_OPEN_ARROW,
          fillColor: '#FFF',
          strokeColor: '#FFF',
          scale: 0.9,
          strokeWeight: 3,
          fillOpacity: 0.8
        }
        this.$refs.mapRef.$mapPromise.then((map) => {
          this.flightPath = new this.google.maps.Polyline({
            path: this.path,
            strokeColor: '#275aff',
            icons: [{
              icon: lineSymbol,
              offset: '0',
              repeat: '5%'
            }],
            strokeOpacity: 0.8,
            strokeWeight: 10
          })
          this.flightPath.setMap(map)
        })
        // this.stratbikemaker()
        if (this.googleFault.length > 0) {
          this.markerPoint.lng = this.googleFault[0].lng
          this.markerPoint.lat = this.googleFault[0].lat
        }
        this.$refs.mapRef.$mapPromise.then((map) => {
          this.flightPath = new this.google.maps.Polyline({
            path: this.googleFault,
            strokeColor: '#FF0000',
            icons: [{ icon: lineSymbol, offset: '0', repeat: '5%' }],
            strokeOpacity: 0.8,
            strokeWeight: 10
          })
          this.flightPath.setMap(map)
        })
      }
    },
    getDistinctArray (arr1, arr2) {
      const result = []
      for (let i = 0; i < arr1.length; i++) {
        let isExist = false
        for (let j = 0; j < arr2.length; j++) {
          if (arr1[i].id === arr2[j].id) {
            isExist = true
            break
          }
        }
        if (!isExist) {
          result.push(arr1[i])
        }
      }
      return result
    },
    reset () {
      this.playbaidu = false
    },
    handleMap ({ BMap, map }) {
      this.map = map
      this.BMap = BMap
      // this.getlngLatAlt()
    },
    getlngLatAlt () {
      this.loading = true
      const data = {
        ebikeId: this.queryInfo.ebikeId,
        startTime: this.queryInfo.searchTime[0],
        endTime: this.queryInfo.searchTime[1]
      }
      lngLatAlt(data).then((res) => {
        this.path = []
        this.pathbaidu = []
        this.tableList = []
        // const tableList = []
        this.bikePath = []
        this.pointsMarker = []
        // const pointsMarker = []
        this.startmarkerPointbaidu = { lng: 0, lat: 0 }
        this.endmarkerPointbaidu = { lng: 0, lat: 0 }
        // const faultDataList1 = []
        // res.data.map((item) => {
        //   if ((item.lat === null && item.lng === null) || item.faultCode !== '48') {
        //     faultDataList1.push(item)
        //   }
        // })
        // const faultDataList1 = []
        // res.data.map((item) => {
        //   if (item.lng !== null && item.lat !== null && item.faultCode === '48') {

        //   } else {
        //     faultDataList1.push(item)
        //   }
        // })
        const faultDataList = this.setDataGroup(res.data)

        console.log('faultDataList===', faultDataList)
        const tableList = []
        faultDataList.map((items) => {
          const obj = {
            activeKey: '',
            faultCode: '',
            list: []
          }
          obj.activeKey = items.activeKey
          obj.faultCode = items.faultCode
          obj.list = []
          items.list.map((itemss) => {
            if (itemss.lng !== null && itemss.lat !== null && itemss.faultCode === '48' && itemss.isLocation === 1) {

            } else {
              obj.list.push(itemss)
            }
            itemss.index = items.index
          })
          tableList.push(obj)
        })
        tableList.map((item, index) => {
          if (item.list.length > 0) {
            this.tableList.push(item)
          }
        })
        // console.log('faultDataList===', this.tableList)
        // console.log('faultDataList===1', faultDataList1)
        res.data.map((item) => {
          // if (item.faultCode !== '48') {
          //   tableList.push(item)
          // }
          if (item.lng && item.lat) {
            this.bikePath.push(item)
          }
        })
        this.bikePath.forEach((item) => {
          // const bikepoints = coordtransform.wgs84togcj02(item.lng, item.lat)
          // const bikepointss = coordtransform.gcj02tobd09(bikepoints[0], bikepoints[1])
          // if (item.isLocation === 1) {
          this.pathbaidu.push({
            lng: item.lng,
            lat: item.lat
          })
          // }
          // if (item.faultCode !== '48') {
          // this.pathbaiduFault.push({
          //   lng: Number(bikepointss[0]),
          //   lat: Number(bikepointss[1])
          // })
          // }
          // var obj = { dataTime: '', fault: { lng: '', lat: '' } }
          // obj.dataTime = item.dataTime
          // obj.fault.lng = Number(bikepointss[0])
          // obj.fault.lat = Number(bikepointss[1])
          // obj.faultCode = item.faultCode
          // pointsMarker.push(obj)
        })
        // const pointsMarkerList = this.setDataGroup(pointsMarker)
        // setTimeout(() => {
        //   pointsMarkerList.map((item) => {
        //     if (item.faultCode !== '48') {
        //       item.fault = []
        //       item.list.map((items) => {
        //         item.fault.push(items.fault)
        //       })
        //       this.pathbaiduFault.push(item)
        //     }
        //   })
        //   console.log('pointsMarkerList====', this.pathbaiduFault)
        // }, 100)
        console.log('pathbaidu===', this.pathbaidu)
        if (this.pathbaidu) {
          this.markerPointbaidu.lng = this.pathbaidu[0].lng
          this.markerPointbaidu.lat = this.pathbaidu[0].lat
          this.startmarkerPointbaidu.lng = this.pathbaidu[0].lng
          this.startmarkerPointbaidu.lat = this.pathbaidu[0].lat
          this.endmarkerPointbaidu.lng = this.pathbaidu[this.pathbaidu.length - 1].lng
          this.endmarkerPointbaidu.lat = this.pathbaidu[this.pathbaidu.length - 1].lat
        }
        this.loading = false
        this.playbaidu = true
        this.isStart = true
        this.setTrajectory()
      }).catch(() => {
        this.loading = false
      })
    },
    setTrajectory () {
      var T = window.T
      var zoom = 17
      this.tdtMap = new T.Map('mapDiv')
      this.tdtMap.centerAndZoom(new T.LngLat(this.markerPointbaidu.lng, this.markerPointbaidu.lat), zoom)
      const control = new T.Control.Zoom()
      this.tdtMap.addControl(control)
      this.createStartMarker()
      this.createRoute()
    },
    createStartMarker () {
      var T = window.T
      const start = {
        lat: this.startmarkerPointbaidu.lat,
        lng: this.startmarkerPointbaidu.lng
      }
      var startMarker = new T.Marker(start, {
        icon: new T.Icon({
          iconUrl: this.startmarkericonbaidu.url,
          iconSize: new T.Point(32, 32),
          iconAnchor: new T.Point(16, 32)
        })
      })
      this.tdtMap.addOverLay(startMarker)
      const end = {
        lat: this.endmarkerPointbaidu.lat,
        lng: this.endmarkerPointbaidu.lng
      }
      var endMarker = new T.Marker(end, {
        icon: new T.Icon({
          iconUrl: this.endmarkericonbaidu.url,
          iconSize: new T.Point(32, 32),
          iconAnchor: new T.Point(16, 32)
        })
      })
      this.tdtMap.addOverLay(endMarker)
    },
    createRoute () {
      var T = window.T
      const that = this
      that.carTrack = new T.CarTrack(this.tdtMap, {
        carstyle: {
          iconUrl: this.icon.url,
          width: 32,
          height: 32
        },
        interval: 200,
        speed: this.speedbaidu,
        dynamicLine: false,
        Datas: this.pathbaidu,
        polylinestyle: { color: '#275aff', width: 8, opacity: 0.8 },
        passOneNode: function (lnglat, index, length) {
          // console.log('===' + index, lnglat)
          if (index === length) {
            that.carTrack.pause()
            that.isStart = false
          }
        }
      })
      that.carTrack.start()
      // this.vehicles.push(that.carTrack)
    },
    changeSlider () {
      this.carTrack.options.speed = this.speedbaidu
      this.carTrack.start()
      console.log('==', this.carTrack)
    },
    setDataGroup (list) {
      // console.log('原数组----')
      // console.log(list)
      const result = {}
      var activeKey = ''
      var activeFaultCode = ''
      var activeIsLocation = ''
      list.map((item, index) => {
        // if (item.faultCode !== activeFaultCode && item.isLocation !== activeIsLocation) {
        if (item.faultCode !== activeFaultCode) {
          activeFaultCode = item.faultCode
          activeIsLocation = item.isLocation
          activeKey = 'activeKey-' + index
          result[activeKey] = {
            faultCode: '',
            activeKey: index,
            list: []
          }
          result[activeKey].faultCode = item.faultCode
          result[activeKey].list.push(item)
        } else {
          if (item.isLocation !== activeIsLocation) {
            activeIsLocation = item.isLocation
            activeKey = 'activeKey-' + index
            result[activeKey] = {
              faultCode: '',
              activeKey: index,
              list: []
            }
            result[activeKey].faultCode = item.faultCode
            result[activeKey].list.push(item)
          } else {
            result[activeKey].list.push(item)
          }
          // result[activeKey].list.push(item)
        }
      })
      // console.log('区间分组数据----')
      // console.log(result)
      const faultDataList = []
      for (const key in result) {
        // console.log('key的值是：' + key)
        faultDataList.push(result[key])
      }
      // console.log('faultDataList====', faultDataList)
      return faultDataList
    },
    handleQuery () {
      this.carTrack.stop()
      // this.carTrack.clear()
      // this.carTrack.createRoute()
      this.carTrack.start()
      this.isStart = true
      // // this.playbaidu = true
      // this.$refs.lushu.originInstance.stop()
      // const newStartPoint = new this.BMap.Point(this.pathbaidu[0].lng, this.pathbaidu[0].lat)
      // // console.log('====', newStartPoint)
      // this.$refs.lushu.originInstance._marker.setPosition(newStartPoint)
      // this.$refs.lushu.originInstance.start()
      // // this.markerPointbaidu.lng = 0
      // // this.markerPointbaidu.lat = 0
      // setTimeout(() => {
      //   // this.map.setZoom(20)
      //   this.markerPointbaidu.lng = this.pathbaidu[0].lng
      //   this.markerPointbaidu.lat = this.pathbaidu[0].lat
      //   this.markerPointbaidu = { lng: this.markerPointbaidu.lng, lat: this.markerPointbaidu.lat }
      // }, 100)
    },
    handPathStop () {
      // this.playbaidu = !this.playbaidu
      // console.log('this.playbaidu-------', this.playbaidu)
      // console.log('this.playbaidu-------', this.playbaidu)
      // console.log('this.playbaidu-------', this.playbaidu)
      this.isStart = !this.isStart
      if (!this.isStart) {
        this.carTrack.pause()
      } else {
        this.carTrack.start()
      }
    },
    bikePolyLine () {
      var lineSymbol = {
        path: this.google.maps.SymbolPath.FORWARD_OPEN_ARROW,
        fillColor: '#FFF',
        strokeColor: '#FFF',
        scale: 0.9,
        strokeWeight: 3,
        fillOpacity: 0.8
      }
      this.stratbikemaker()
      this.$refs.mapRef.$mapPromise.then((map) => {
        this.flightPath = new this.google.maps.Polyline({
          path: this.path,
          strokeColor: '#275aff',
          icons: [{
            icon: lineSymbol,
            offset: '0',
            repeat: '5%'
          }],
          strokeOpacity: 0.8,
          strokeWeight: 10
        })
        this.flightPath.setMap(map)
      })
    },
    bikePolyLinestart () {
      clearInterval(this.car_animate)
      this.car_animate = setInterval(() => {
        this.markerBlack.setIcon(this.bikemarkericon)
        this.markerBlack.setPosition(this.path[this.count])
        this.count += 1
        this.count2 = this.count
        if (this.count === this.path.length) {
          this.markerBlack.setPosition(this.path[this.path.length - 1])
          this.count2 = 0
          this.count = 0
          clearInterval(this.car_animate)
        }
      }, (1 / this.speed) * this.path)
    },
    stratbikemaker () {
      this.$refs.mapRef.$mapPromise.then((map) => {
        this.markerBlack = new this.google.maps.Marker({
          position: this.path[0],
          icon: this.bikemarkericon
        })
        this.markerBlack.setMap(map)
      })
    },
    inputspeed (speed) {
      this.speed = speed
    },
    mapchangeradio () {
      this.clickIndex = -1
      if (this.mapchange === '1') {
        // clearInterval(this.car_animate)
        // this.pathbaidu = []
        // this.bikePath.forEach((item) => {
        //   const bikepoints = coordtransform.wgs84togcj02(item.lng, item.lat)
        //   const bikepointss = coordtransform.gcj02tobd09(bikepoints[0], bikepoints[1])
        //   this.pathbaidu.push({
        //     lng: Number(bikepointss[0]),
        //     lat: Number(bikepointss[1])
        //   })
        //   if (item.faultCode !== 48 + '') {
        //     var obj = { dataTime: '', fault: { lng: '', lat: '' } }
        //     obj.dataTime = item.dataTime
        //     obj.fault.lng = Number(bikepointss[0])
        //     obj.fault.lat = Number(bikepointss[1])
        //     this.pointsMarker.push(obj)
        //   }
        // })
        // console.log('this.pointsMarker====', this.pointsMarker)
        // if (this.pathbaidu) {
        //   this.markerPointbaidu.lng = this.pathbaidu[0].lng
        //   this.markerPointbaidu.lat = this.pathbaidu[0].lat
        //   this.startmarkerPointbaidu.lng = this.pathbaidu[0].lng
        //   this.startmarkerPointbaidu.lat = this.pathbaidu[0].lat
        //   this.endmarkerPointbaidu.lng = this.pathbaidu[this.pathbaidu.length - 1].lng
        //   this.endmarkerPointbaidu.lat = this.pathbaidu[this.pathbaidu.length - 1].lat
        // }
      } else {
        this.path = []
        this.bikePath.forEach((item) => {
          if (this.chinascope(item.lng, item.lat) === true) {
            const bikepoint = coordtransform.wgs84togcj02(item.lng, item.lat)
            this.path.push({
              lng: Number(bikepoint[0]),
              lat: Number(bikepoint[1])
            })
          } else {
            this.path.push({
              lng: Number(item.lng),
              lat: Number(item.lat)
            })
          }
        })
        this.markerPoint.lng = this.path[0].lng
        this.markerPoint.lat = this.path[0].lat
        this.startmarkerPoint.lng = this.path[0].lng
        this.startmarkerPoint.lat = this.path[0].lat
        this.endmarkerPoint.lng = this.path[this.path.length - 1].lng
        this.endmarkerPoint.lat = this.path[this.path.length - 1].lat
        setTimeout(() => {
          this.bikePolyLine()
          this.bikePolyLinestart()
        }, 100)
      }
    },
    chinascope (lng, lat) {
      if (lng < 72.004 || lng > 137.8347 || lat < 0.8293 || lat > 55.8271) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.visualReport-container {
  display: flex;
  flex-direction: column;
  width: 100%;

  .caution {
    width: 35px;
    height: 35px;
  }

  .elCol {
    display: flex;
    flex-direction: row;
  }

  .redColor {
    color: red;
  }

  .top-ds {
    width: calc(100% - 30px);
    display: flex;
    justify-content: space-between;
    height: 100px;
    border: 1px solid #f1f1f1;
    margin-bottom: 20px;
    padding: 0px 15px;

    .item {
      width: 100%;
      display: flex;
      flex-direction: column;
      height: 100px;
      justify-content: center;

      .label {
        font-size: 18px;
        font-weight: 700;
      }

      .value {
        font-family: 'D-DIN-PRO-700';
        font-size: 18px;
      }

      .margin-top10 {
        margin-top: 10px;
      }
    }
  }

  .margin-top20 {
    margin-top: 20px;
  }

  .map-radio {
    display: flex;
    z-index: 999;
    position: absolute;
    left: 60px;
    top: 15px;
    align-items: center;
  }

  .writing-mode {
    writing-mode: vertical-rl;
  }

  .dydl-wd {
    width: 100%;
    display: flex;
    flex-direction: row;

    .dydl-container {
      position: relative;
      width: 50%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      border: 1px solid #f1f1f1;
      padding: 10px;
    }

    .dydl {
      width: 100%;
      height: 400px;
    }

    .bll-select {
      width: 180px;
      margin-left: 20px;
      position: absolute;
      left: 0;
      top: 10px;
      display: flex;
      z-index: 999;
      justify-content: space-between;
      align-items: center;
    }

    .wd-text {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-weight: 600;
    }

    .dcdy {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #42bf7c;
      font-weight: 600;
    }

    .dcdl {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #5a7ff1;
      font-weight: 600;
    }

    .gz-table {
      width: 100%;
      display: flex;
      flex-direction: column;
      height: 400px;
      padding: 10px;

      .title {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 20px;
      }

      .row1 {
        width: 25%;
        // padding-left: 10px;
        // padding-right: 15px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .row2 {
        width: 20%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .row3 {
        width: 30%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .row4 {
        width: 20%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .row5 {
        width: 5%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .icon {
        width: 25px;
        height: 25px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .table-title {
        width: 100%;
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        font-weight: 600;
        padding: 10px 0px;
        border-bottom: 1px solid #f1f1f1;
      }

      .table-content {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        height: 360px;
        overflow: auto;
        margin-top: 10px;
      }

      .nodata {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      .item-content-active {
        background: #f1f1f1;
      }

      .item-content {
        width: 100%;
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        padding: 10px 0px;
        align-items: center;
      }
    }

    .margin-left15 {
      margin-left: 15px;
    }

    .wd-container {
      position: relative;
      width: 50%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      border: 1px solid #f1f1f1;
      padding: 10px;

      .wd {
        width: 100%;
        height: 400px;
      }
    }
  }

  .baidu-map {
    width: 100%;
    position: relative;
  }

  .gooles-map {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .map {
    width: 100%;
    height: 420px;
  }

  .el-icon-rank {
    font-size: 24px;
    color: black;
    position: absolute;
    bottom: 15px;
    right: 15px;
    z-index: 999;
    cursor: pointer;
  }

  .full-map {
    .map {
      width: 100%;
      height: 800px;
    }

    .query-form {
      display: flex;
      flex-direction: column;
      z-index: 999;
      position: absolute;
      top: 80px;
      left: 50px;

      .gjsd {
        display: flex;
        flex-direction: row;
        align-items: center;
      }
    }
  }

  .query-form {
    display: flex;
    flex-direction: column;
    z-index: 999;
    position: absolute;
    top: 20px;
    left: 50px;

    .gjsd {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }

  .input {
    width: px2vw(147);
  }

  .form-item2 {
    margin-left: px2vw(-15);
  }

  .bt-layout {
    display: flex;
    flex-direction: row;
    height: 36px;
  }
}
</style>
